import { AppointmentStatus } from '@dreryk/egabinet-appointment-frontend-api';
import { VisitStatus } from '@dreryk/egabinet-visit-frontend-api';

import { assertUnreachable } from '~libs.typescript';

export const shouldShowVideoConsultationUrl = (
   appointmentStatus: AppointmentStatus,
   visitStatus?: VisitStatus
): boolean => {
   if (!visitStatus) {
      switch (appointmentStatus) {
         case 'REGISTERED':
            return true;
         case 'CANCELLED':
         case 'COMPLETED':
            return false;
         default:
            return assertUnreachable(appointmentStatus);
      }
   }

   switch (visitStatus) {
      case 'IN_PROGRESS':
      case 'FINISHED_NOT_APPROVED':
         return true;
      case 'FINISHED_APPROVED':
      case 'CANCELLED':
         return false;
      default:
         return assertUnreachable(visitStatus);
   }
};
